import { Divider, Flex, Text, Tooltip } from "@mantine/core";
import style from "./follow-up-illustration.module.css";
import { useTranslation } from "react-i18next";

import crossIcon from './../../../../../../assets/cross.svg';
import editIcon from './../../../../../../assets/edit.png';

const FollowUpIllustration = () => {
    const { t } = useTranslation(["landing-page"]);

    const followUpQuestions = [
        {
            question: t('follow_up.questions.0.question'),
            answer: t('follow_up.questions.0.answer'),
        },
        {
            question: t('follow_up.questions.1.question'),
            answer: t('follow_up.questions.1.answer'),
        },
        {
            question: t('follow_up.questions.2.question'),
            answer: t('follow_up.questions.2.answer'),
        },
    ];

    return (
        <div className={style.screenshotWrapper}>
            <div className={style.cardList}>
                <Text color="dark" fw={600} fz={"13px"} mb={"0.5rem"} >{t('follow_up.tab_title')}</Text>

                {followUpQuestions.map((followUpQuestion, index) => (
                    <FUQItem key={index} answer={followUpQuestion.answer} question={followUpQuestion.question} index={index} />
                ))}
            </div>
        </div>
    );
};

export default FollowUpIllustration;

const FUQItem = ({ answer, question, index }) => {
    const { t } = useTranslation(["landing-page"]);

    return (
        <div>
            <Divider />
            <Flex py={"0.5rem"} px={"0.5rem"} gap={"0.25rem"}>
                <Text style={{ fontSize: "12px" }} fw={500}>{`${index + 1}.`}</Text>
                {answer ? (
                    <Flex direction={"column"} gap={"0.25rem"}>
                        <Text style={{ fontSize: "12px" }} fw={500}>
                            {question}
                        </Text>

                        <Text style={{ fontSize: "11px" }}>
                            <i>{`${t("follow_up.answer_label")}: `}</i>
                            <span>{answer}</span>
                        </Text>
                    </Flex>
                ) : (
                    <Text style={{ fontSize: "12px" }}>{question}</Text>
                )}

                <div className={style.cardItemRight}>
                    <span />
                    <Tooltip label={t("follow_up.edit")} withArrow>
                        <div className={style.optionIconButton}>
                            <img className={style.optionIcon} src={editIcon} alt="edit"></img>
                        </div>
                    </Tooltip>

                    <Tooltip label={t("follow_up.delete")} withArrow>
                        <div className={`${style.optionIconButton} plausible-event-name=deleteFollowUpQuestion`}>
                            <img className={style.optionIcon} src={crossIcon} alt="delete"></img>
                        </div>
                    </Tooltip>
                </div>
            </Flex>
        </div>
    );
};
